import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../css/Result.css'


const Result = ({ score, total, answers }) => {
    const [expandedRow, setExpandedRow] = useState(null);

    const handleRowClick = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    return (
        <div className="modern-container">
            <div className="modern-section">
                {/* Header */}
                <div className="text-center fade-in-up" style={{ marginBottom: 'var(--spacing-2xl)' }}>
                    <h2 style={{ 
                        fontSize: '2.5rem',
                        background: 'var(--success-gradient)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        marginBottom: 'var(--spacing-lg)'
                    }}>
                        🎉 クイズ完了！
                    </h2>
                    
                    {/* Score Display */}
                    <div className="modern-card" style={{ 
                        maxWidth: '400px', 
                        margin: '0 auto',
                        background: 'var(--primary-gradient)',
                        color: 'white'
                    }}>
                        <div className="modern-card-body text-center">
                            <h3 style={{ 
                                color: 'white',
                                marginBottom: 'var(--spacing-md)'
                            }}>
                                あなたのスコア
                            </h3>
                            <div style={{ fontSize: '3rem', fontWeight: 'bold' }}>
                                {score} / {total}
                            </div>
                            <div style={{ fontSize: '1.25rem', opacity: 0.9 }}>
                                正答率: {Math.round((score / total) * 100)}%
                            </div>
                        </div>
                    </div>
                </div>

                {/* Results Table */}
                <div className="modern-card fade-in-up" style={{ marginBottom: 'var(--spacing-2xl)' }}>
                    <div className="modern-card-header">
                        <h4 style={{ margin: 0, color: 'var(--text-primary)' }}>
                            詳細結果
                        </h4>
                    </div>
                    <div style={{ overflow: 'auto' }}>
                        {answers.map((answer, index) => (
                            <div key={index}>
                                <div 
                                    style={{
                                        padding: 'var(--spacing-lg)',
                                        borderBottom: '1px solid var(--border-color)',
                                        cursor: 'pointer',
                                        transition: 'background-color var(--transition-fast)',
                                        display: 'grid',
                                        gridTemplateColumns: '40px 1fr 1fr 1fr 80px',
                                        gap: 'var(--spacing-md)',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => handleRowClick(index)}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--surface-hover)'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    <div style={{ fontWeight: 'bold', color: 'var(--text-muted)' }}>
                                        {index + 1}
                                    </div>
                                    <div style={{ fontWeight: '600', color: 'var(--text-primary)' }}>
                                        {answer.question}
                                    </div>
                                    <div style={{ 
                                        color: answer.isCorrect ? 'var(--success-color)' : 'var(--danger-color)',
                                        fontWeight: '500'
                                    }}>
                                        {answer.selectedOption}
                                    </div>
                                    <div style={{ color: 'var(--text-secondary)' }}>
                                        {answer.correctAnswer}
                                    </div>
                                    <div>
                                        <span className={`modern-badge ${answer.isCorrect ? 'modern-badge-success' : 'modern-badge-danger'}`}>
                                            {answer.isCorrect ? '正解' : '不正解'}
                                        </span>
                                    </div>
                                </div>
                                <Collapse in={expandedRow === index}>
                                    <div style={{ 
                                        padding: 'var(--spacing-lg)',
                                        backgroundColor: 'var(--background-primary)',
                                        borderBottom: '1px solid var(--border-color)',
                                        fontStyle: 'italic',
                                        color: 'var(--text-secondary)'
                                    }}>
                                        <strong>例文:</strong> {answer.example || "例文がありません。"}
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="text-center fade-in-up">
                    <Link 
                        to="/" 
                        className="modern-btn modern-btn-primary"
                        style={{ minWidth: '200px' }}
                    >
                        ホームに戻る
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Result;
